import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import UserDateTimezoneFormat from '../../../components/user-date-timezone-format';
import { useSalesOrderForFulfillmentId } from '../../../hooks/entities/selectors/fulfillments';
import { messages } from '../messages';

const OrderDate = ({ fulfillmentId }) => {
  const salesOrder = useSalesOrderForFulfillmentId(fulfillmentId);
  const { orderDateTime } = salesOrder ?? {};

  return orderDateTime ? <UserDateTimezoneFormat dateTime={orderDateTime} /> : '';
};

OrderDate.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const orderDate = {
  getMessageDescriptor: () => messages.orderDate,
  name: <FormattedMessage {...messages.orderDate} />,
  id: 'orderDate',
  render: (data) => <OrderDate fulfillmentId={data.id} />,
};
